import Swiper from "swiper/bundle";
import "swiper/css/bundle";
const partnersSlider = new Swiper(".partners-slider", {
  autoHeight: true,
  slidesPerView: "auto",
  spaceBetween: 11,

  allowTouchMove: false,
  speed: 4000,
  autoplay: {
    delay: 0,
  },
  breakpoints: {
    992: {
      spaceBetween: 40,
    },
  },
  loop: true,
});
